const _ = require('lodash');

module.exports = function(number) {
	let price;

	// sanity check
	if (!number) {
		return null;
	}

	price = "$" + Math.round(Number(number));

	return price;
};



// WEBPACK FOOTER //
// ./src/utils/getRoundedPrice.js